import { Suspense } from 'react';

import { PageLoader } from './PageLoader';
import { QueryProvider } from './QueryProvider';

type GlobalProvidersProps = {
	children: React.ReactNode;
};

export const GlobalProviders = ({
	children,
}: GlobalProvidersProps): JSX.Element => (
	<Suspense fallback={<PageLoader />}>
		<QueryProvider>
			<>{children}</>
		</QueryProvider>
	</Suspense>
);
